import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/best-4-sustainable-travel-companies-2022`;

  return (
    <MainLayout additionalClassName="blogPost">
      <NextSeo
        title="Best 4 Sustainable Travel Tours | Win Epic Prizes | DAYMADE"
        description="Discover the best 4 sustainable travel companies to have the adventure of a lifetime and make a positive impact. Enter now for a chance to win."
        openGraph={{
          title: 'Best 4 Sustainable Travel Tours | Win Epic Prizes | DAYMADE',
          description:
            'Discover the best 4 sustainable travel companies to have the adventure of a lifetime and make a positive impact. Enter now for a chance to win.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/best-4-sustainable-travel-companies-2022',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'A girl is laying in a hammock, looking out into the forest and mountains.',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'winner,lottery,daymade,jackpot,raffle,holiday competitions,win prizes,win a prize,win a free trip,hipcamp,adventure tours uk,much better adventures,canopy and stars,glamping,outdoors,kayaking,retreats,hiking,sustainable travel,local experiences,eco-friendly travel,win a trip,win a luxury holiday,win gift cards,holiday prizes to win,',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="A girl is laying in a hammock, looking out into the forest and mountains"
        heroImageYPosition="0%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            The Best 4 Sustainable Travel Companies in 2022
          </h1>

          <p className="subheading">
            Epic travel adventures that make you and the planet feel good
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Violet Currey
          </p>

          <p>
            We've all become champs in living more eco-friendly lives and making
            choices that love the planet. If you're like us, we're obsessed with
            travelling to experience new cultures, try new cuisines, and see the
            wonders of the world. The big question is: How can we travel more
            sustainably?
          </p>

          <p>
            Sustainable travel is now hot on everyone's radar. It's time to get
            you on your way to having epic adventures and helping the planet
            along the way. Sustainable travelling isn't just about packing our
            reusable bits and bobs. It's about being mindful of our carbon
            footprint, supporting locals and taking the slow travel lane.
            DAYMADE is about unforgettable travel experiences that make you and
            the planet feel good. Sustainable travel covers a huge list; ticking
            all boxes could seem a little daunting. Not to worry, though: we've
            got you covered to kick off your next sustainable travel journey.
            Check out the four best travel companies changing how we travel for
            good. Plus, you could be in with a chance to win gift cards and
            travel prizes so you can book your dream getaway.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="A group of friends hiking in the forest"
            className="singleBlogImage"
          />

          <h2>Adventure Tours UK</h2>

          <p>
            We're big fans of{' '}
            <a
              href="https://www.daymade.co.uk/prizes/details/adventure-tours-giftcard-300"
              target="_blank"
              rel="noreferrer"
            >
              Adventure Tours UK
            </a>{' '}
            because they are just as passionate about planting trees as we are!
            Adventure Tours UK is proud to be a responsible travel provider. It
            works closely with accommodations and activity partners to ensure
            they share the same earth-loving values. You're guaranteed a
            low-carbon holiday in the best wild spaces in the UK. The best news
            is that Adventure Tours UK has created bucket-list-worthy tours to
            suit any adventurer. Fancy escaping the hustle and bustle of
            everyday life? Join their lovely wellness retreats to recharge your
            batteries. Or maybe you're a thrill seeker who wants to burn off
            some steam with their adventure collection holidays: kayaking,
            hiking and mountain biking (yes, please!). Have your next nature
            holiday with Adventure Tours UK, so you can positively impact our
            planet while taking in its wonders.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Two friends are kayaking in the river."
            className="singleBlogImage"
          />

          <h2>Much Better Adventures</h2>

          <p>
            Authentic, local, and intimate experiences are the main ingredients
            to having the best adventures.{' '}
            <a
              href="https://www.daymade.co.uk/prizes/details/much-better-adventures-2000"
              target="_blank"
              rel="noreferrer"
            >
              Much Better Adventures
            </a>{' '}
            ticks all of these boxes. You can have a feel-good getaway by
            supporting local businesses in rural areas whilst having the time of
            your life. Much Better Adventures offers unique getaways worldwide,
            from cycling around Cuba and yoga retreats in Devon to Arctic hikes.
            You'll indeed have an experience of a lifetime while giving back to
            build rural economies to preserve some of the world's natural
            beauty. You'll be sure to create unforgettable memories and leave
            behind a positive contribution that will make you feel good for
            years to come.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="Cyclists in the Caucasus Mountains of Georgia"
            className="singleBlogImage"
          />

          <h2>Canopy & Stars</h2>

          <p>
            We've got another nature-loving outdoors company for you. Canopy &
            Stars is part of Saw Day's group focused on creating experiences
            that positively impact the planet and allow us to reconnect with
            mother nature. What makes Canopy and Stars so unique is their love
            for supporting independent businesses and helping the environment
            with all of their stays. Have the most unusual sleepovers and stay
            in tree houses, mountain tops, and cabins in the forest. Have a
            staycation adventure with no flying involved (hooray!). We have this
            epic prize to be won in our raffle competitions, so keep an eye out
            to have your next outdoorsy break on us.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt="A tree house accommodation with two floors in the woods"
            className="singleBlogImage"
          />

          <h2>HipCamp</h2>

          <p>
            The best way to travel sustainability is to support your local
            nature reserves and access the incredible wildlife of the UK.{' '}
            <a
              href="https://www.daymade.co.uk/prizes/details/hipcamp-300"
              target="_blank"
              rel="noreferrer"
            >
              Hipcamp
            </a>{' '}
            is the online booking platform with 100s of outdoor adventures, from
            campervans to out-of-this-world glamping. HipCamp works closely with
            partners to provide responsible travel and promotes leaving no trace
            during your outdoor adventure. Hipcamp is on a mission to protect
            natural spaces and make them accessible for everyone to reconnect
            with nature. Rediscover your passion for caring for the environment
            around us. Sometimes, we need to unplug and escape to enjoy our
            scenic surroundings. A trip with HipCamp guarantees you to support
            local land owners, get some good old fresh air, and surround
            yourself with epic natural beauty. A win-win situation if we do say
            so ourselves!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary5.jpg`}
            alt="A VW campervan parked next to a lake with the sunset in the background."
            className="singleBlogImage"
          />

          <p>
            Travelling is the key to creating unforgettable memories,
            reconnecting with yourself, and sharing moments that will last a
            lifetime. If there's one thing that the last two years have taught
            us, it's to slow down and be mindful of our travel choices. Make
            sure your next trip supports your locals, loves your planet, and
            positively impacts our environment. We're buzzing to be partnered
            with some of the best sustainable travel companies for you to win a
            holiday, so your day is made. (and earth's day too, yay!)
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary6.jpg`}
            alt="A family of 5 sat on a tree log looking out into the mountains."
            className="singleBlogImage"
          />

          <Separator style={{ margin: '1em 0 2.5em' }} />

          <p>
            Begin your sustainable travel journey today. Enter now to be in a
            chance to win your next sustainable adventure.
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1em 0 1.5em' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
